import { RefObject, useLayoutEffect } from "react";
import { Dimensions } from "../types/dimensions";
import { Coordinate } from "../types/coordinate";

export type ResizeCallback = (state: Dimensions & Coordinate) => void;

const getState = (element: Element): Dimensions & Coordinate => {
  const { width, height, x, y } = element.getBoundingClientRect();
  return { width, height, x, y };
};

const useResizeObserver = (
  on: boolean,
  ref: RefObject<Element>,
  callback: ResizeCallback
) => {
  useLayoutEffect(() => {
    if (on && ref.current !== null) {
      const element = ref.current;

      callback(getState(element));
      const handler = () => {
        if (element !== null) {
          callback(getState(element));
        }
      };

      const observer = new ResizeObserver(handler);
      observer.observe(element);
      window.addEventListener("resize", handler);

      return () => {
        observer.unobserve(element);
        observer.disconnect();
        window.removeEventListener("resize", handler);
      };
    }
    return undefined;
  }, [on, callback, ref]);
};

export default useResizeObserver;
